import type { ApplyStatusResult } from './resolveCampaignCta';

export type GateDialog =
  | { type: 'review'; applicationId: string }
  | { type: 'delivery' }
  | { type: 'verify' };

type ResolveGateDialogListParams = Pick<
  ApplyStatusResult,
  | 'applyStatus'
  | 'inProgressReason'
  | 'inProgressApplicationId'
  | 'myApplicationId'
> & {
  verification?: Pick<
    NonNullable<ApplyStatusResult['verification']>,
    'requiredInfoComplete'
  >;
};

//* 참여 중 사유는 applyStatus 우선순위에 가리지 않고 따로 오므로 단계와 독립으로 안내한다(기획: 후기 → 본인인증 순)
export const resolveGateDialogList = ({
  applyStatus,
  inProgressReason,
  inProgressApplicationId,
  myApplicationId,
  verification,
}: ResolveGateDialogListParams): GateDialog[] => {
  if (applyStatus === 'BLOCKED' || applyStatus === 'RESTRICTED') {
    return [];
  }

  const isOwnApplication =
    Boolean(inProgressApplicationId) &&
    inProgressApplicationId === myApplicationId;
  const inProgressDialog = ((): GateDialog | null => {
    if (isOwnApplication) {
      return null;
    }
    if (inProgressReason === 'REVIEW_REQUIRED' && inProgressApplicationId) {
      return { type: 'review', applicationId: inProgressApplicationId };
    }

    return inProgressReason === 'DELIVERY_PENDING'
      ? { type: 'delivery' }
      : null;
  })();
  const needsVerify =
    applyStatus === 'VERIFY_REQUIRED' ||
    (applyStatus === 'IN_PROGRESS' && !verification?.requiredInfoComplete);

  return [
    ...(inProgressDialog ? [inProgressDialog] : []),
    ...(needsVerify ? [{ type: 'verify' as const }] : []),
  ];
};
